import React from 'react';
import Modal from 'react-modal';

Modal.setAppElement('#root')

function ProjectDetails({ project, onClose }) {
  return (
    <Modal isOpen={true} onRequestClose={onClose}>
      <button onClick={onClose} className='backBtn'>Back</button>
      <h2 className='projectH2'>{project.name}</h2>
      <img src={project.img} alt="" className='imgPreview' />
      <p>{project.details}</p>
      <a href={project.link} className='visitProjectBtn'>Visit project</a>
      <br />

    </Modal>
  );
}

export default ProjectDetails;
